export default __webpack_public_path__ + "static/media/faceToFace.836486b2.svg";